import { Container, Text, type TextStyleOptions } from 'pixi.js';

export interface GameOverSceneConfig {
  canvasWidth: number;
  canvasHeight: number;
}

export interface GameOverScene {
  container: Container;
  titleText: Text;
  scoreText: Text;
  promptText: Text;
  destroy(): void;
}

const TITLE_STYLE: TextStyleOptions = {
  fontFamily: 'monospace',
  fontSize: 56,
  fontWeight: 'bold',
  fill: 0xff3333,
  letterSpacing: 4,
};

const SCORE_STYLE: TextStyleOptions = {
  fontFamily: 'monospace',
  fontSize: 28,
  fontWeight: 'bold',
  fill: 0xffffff,
};

const PROMPT_STYLE: TextStyleOptions = {
  fontFamily: 'monospace',
  fontSize: 20,
  fontWeight: 'bold',
  fill: 0xffffff,
};

function formatScore(score: number): string {
  return `SCORE: ${String(score).padStart(4, '0')}`;
}

export function createGameOverScene(
  parent: Container,
  finalScore: number,
  config: GameOverSceneConfig,
): GameOverScene {
  const container = new Container();
  container.label = 'game-over-scene';
  parent.addChild(container);

  const cx = config.canvasWidth / 2;
  const cy = config.canvasHeight / 2;

  const titleText = new Text({ text: 'GAME OVER', style: TITLE_STYLE });
  titleText.anchor.set(0.5, 0.5);
  titleText.x = cx;
  titleText.y = cy - 80;
  container.addChild(titleText);

  const scoreText = new Text({
    text: formatScore(finalScore),
    style: SCORE_STYLE,
  });
  scoreText.anchor.set(0.5, 0.5);
  scoreText.x = cx;
  scoreText.y = cy;
  container.addChild(scoreText);

  const promptText = new Text({
    text: 'PRESS SPACE TO RESTART',
    style: PROMPT_STYLE,
  });
  promptText.anchor.set(0.5, 0.5);
  promptText.x = cx;
  promptText.y = cy + 70;
  container.addChild(promptText);

  return {
    container,
    titleText,
    scoreText,
    promptText,
    destroy() {
      container.destroy({ children: true });
    },
  };
}
